import { Ng2StateDeclaration } from '@uirouter/angular';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { ListViewSettingsService } from '@fi-app/utilities/fi-services/list-view-settings.service';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { FiAppearanceListViewEditComponent } from '@fi-app/appearance/list-view/list-view-edit/list-view-edit.component';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiAppearanceResolve_SiteDesignId } from '@fi-app/appearance/states/appearance-start-page-edit-state';

export const FiAppearanceListViewEditState: Ng2StateDeclaration = {
    name: FiStateNames.Appearance.ListView.Edit,
    url: '/Edit?{:siteDesignId}',
    views: {
        '@': {
            component: FiAppearanceListViewEditComponent,
        },
    },
    resolve: {
        siteDesignId: FiAppearanceResolve_SiteDesignId,
        settings: ['siteDesignId', ListViewSettingsService, FiAppearanceListViewEditStateResolveSettings],
        pageTitle: [PageTitleService, FiAppearanceListViewEditStateResolvePageTitle],
    },
};

export function FiAppearanceListViewEditStateResolveSettings(
    siteDesignId: number,
    settingsService: ListViewSettingsService,
) {
    return settingsService.getSettings([/*ObjectTypes.Document, */ ObjectTypes.MediaBank, ObjectTypes.User], {
        siteDesignId: siteDesignId,
    });
}

export function FiAppearanceListViewEditStateResolvePageTitle(ccmPageTitle) {
    return ccmPageTitle.setTitleByTextId('common.appearance');
}
